import React, { useEffect } from "react";
import styles from "../EPLI.module.css";
import TextArea from "uicomponents/TextArea";
import RadioInput from "uicomponents/RadioInput";
import DocumentUpload from "uicomponents/DocumentUpload";
import { useFormikContext } from "formik";
import { EPLIFormType } from "../../../utils/formType";
import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { WCAppType } from "types";

interface IEPLIComponentProps {
  data?: WCAppType;
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const EPLIComponent = ({ ...props }: IEPLIComponentProps): JSX.Element => {
  const { data, fieldRefs } = props;
  const { values, setFieldValue } = useFormikContext();

  const hasEPLIPolicy = (values as EPLIFormType)?.hasPolicy;
  const isBeenSuedFormerEmp = (values as EPLIFormType)?.beenSuedFormerEmp;
  const hasOverTwentyFiveEe = (values as EPLIFormType)?.overTwentyFiveEe;
  const noEpliLossRunsReportOtherReasonReqired = (values as EPLIFormType)
    ?.noEpliLossRunsReportReason;

  const labelList = sectionsQuestions["epli"].questions;
  const messageList = sectionsQuestions["epli"].message;

  useEffect(() => {
    if (isBeenSuedFormerEmp === "No") {
      setFieldValue("claimDetails", "");
    }
  }, [isBeenSuedFormerEmp, setFieldValue]);

  useEffect(() => {
    if (hasOverTwentyFiveEe === "No") {
      setFieldValue("offeredSeverancePackages", "");
    }
  }, [hasOverTwentyFiveEe, setFieldValue]);

  useEffect(() => {
    if (noEpliLossRunsReportOtherReasonReqired !== "Other") {
      setFieldValue("noEpliLossRunsReportOtherReason", "");
    }
  }, [noEpliLossRunsReportOtherReasonReqired, setFieldValue]);

  return (
    <div>
      <div className={styles.title}>{sectionsQuestions["epli"].title}</div>
      <div className={styles.description}>
        {sectionsQuestions["epli"].description}
      </div>
      <RadioInput
        name="hasPolicy"
        label={labelList.hasPolicy}
        options={["Yes", "No"]}
        fieldRefs={fieldRefs}
      />
      {hasEPLIPolicy === "Yes" && (
        <>
          <DocumentUpload
            name="epliDocument"
            label={labelList.epliDocument}
            application={data}
            fieldRefs={fieldRefs}
          />
          <DocumentUpload
            name="epliLossDocument"
            label={labelList.epliLossDocument}
            message={messageList.epliLossDocument}
            application={data}
            required={false}
          />
          <RadioInput
            name="noEpliLossRunsReportReason"
            label={labelList.noEpliLossRunsReportReason}
            options={[
              "Our company didn’t have previous W-2 employees.",
              "We’ll send it when out current carrier provides it.",
              "Other",
            ]}
            required={false}
          />
          {noEpliLossRunsReportOtherReasonReqired === "Other" && (
            <TextArea
              name="noEpliLossRunsReportOtherReason"
              label={labelList.noEpliLossRunsReportOtherReason}
              fieldRefs={fieldRefs}
            />
          )}
        </>
      )}
      <RadioInput
        name="receivedEpliAllegations"
        label={labelList.receivedEpliAllegations}
        options={["Yes", "No"]}
        fieldRefs={fieldRefs}
      />
      <RadioInput
        name="beenSuedFormerEmp"
        label={labelList.beenSuedFormerEmp}
        options={["Yes", "No"]}
        fieldRefs={fieldRefs}
      />
      {isBeenSuedFormerEmp === "Yes" && (
        <TextArea
          name="claimDetails"
          label={labelList.claimDetails}
          fieldRefs={fieldRefs}
        />
      )}
      <RadioInput
        name="overTwentyFiveEe"
        label={labelList.overTwentyFiveEe}
        options={["Yes", "No"]}
        fieldRefs={fieldRefs}
      />
      {hasOverTwentyFiveEe === "Yes" && (
        <RadioInput
          name="offeredSeverancePackages"
          label={labelList.offeredSeverancePackages}
          options={["Yes", "No"]}
          fieldRefs={fieldRefs}
        />
      )}
    </div>
  );
};

export default EPLIComponent;
